import React from 'react';

import { OutboxSubmitWrapper } from '..';
import { TransactionForm } from '../../../../../../components/TransactionForm';
import PaymentFields from '../../../../../../components/transaction/Payment/PaymentFields';
import { PaymentState } from '../../../../../../components/transaction/Payment/form/state';
import useTranslation from '../../../../../../hooks/useTranslation';
import { OutboxEditViewFlow, OutboxStatus, StatusProps } from '../../types';
import DeleteStatus from './DeleteStatus';
import UpdateStatus from './UpdateStatus';

import './ModalBody.scss';

const UPDATE_FLOW_SPECIFIC_STATUSES: OutboxStatus[] = ['success', 'error'];

type EditModalBodyProps = {
    onDelete: () => void;
    onMutate: (event: React.FormEvent<HTMLButtonElement>) => void;
    onSign: () => void;
    initialState: PaymentState;
    flow: OutboxEditViewFlow | undefined;
    status: OutboxStatus | undefined;
} & Omit<StatusProps, 'status'>;

const ModalBody: React.FC<EditModalBodyProps> = ({
    onDelete,
    initialState,
    onSign,
    onMutate,
    onClose,
    flow,
    status,
}) => {
    const translated = useTranslation();
    if (flow === 'deleting' && status) return <DeleteStatus onClose={onClose} onDelete={onDelete} status={status} />;
    if (flow === 'updating' && status && UPDATE_FLOW_SPECIFIC_STATUSES.includes(status))
        return <UpdateStatus onUpdate={onMutate} status={status} onClose={onClose} />;

    return (
        <>
            {status === 'pending' && <div className="modal-body__exit-placeholder" />}
            <h2>{translated.outbox.editPayment}</h2>
            <TransactionForm>
                <PaymentFields locked={status === 'pending'} lockNote lockReceiver showInstant={false} />
                <OutboxSubmitWrapper
                    onSign={onSign}
                    onMutate={onMutate}
                    onClose={onClose}
                    onDelete={onDelete}
                    initialState={initialState}
                    editLoading={status === 'pending'}
                />
            </TransactionForm>
        </>
    );
};

export default ModalBody;
